const {createPipeline} = require("cleopatra");
const axios = require("axios");
const router = require("app/services/router");
const {createPromiseThrottle} = require("app/util/throttle");
const {reportAndThrow} = require("app/util/errors");
const lazyload = require("app/frontend/lazy-load");

const throttle = createPromiseThrottle(500);
const request = createPipeline().report(reportAndThrow);
const response = createPipeline().report(reportAndThrow);

request.pipe(payload => {
	return throttle(payload);
});

request.capture(payload => {
	return axios
		.get(router.route("api.products.index", null, payload))
		.then(payload => {
			return response.dispatch(payload.data)
		})
		.then(payload => {
			lazyload.ieCheck() ?
				lazyload.ieResolve(document.querySelectorAll('[lazy-load]')) :
				lazyload.resolveLazyLoad(document.querySelectorAll('[lazy-load]'));

			return payload;
		})
});

module.exports = {
	request,
	response
};
